<template>
  <cumulus-info-dialog
    v-model="operatingDayInfo"
    icon="$info"
    :title="$t('operating_day_informations')"
    activator-icon
    @escape="closeDialogOperatingDayInfo"
  >
    <template v-slot:info>
      <v-card-text>
        <v-col
          :class="{'red--text': operatingDay.coordinator_sr}"
        >
          {{ $t('fields.coordinator_id') }}: {{ operatingDay.coordinator ? operatingDay.coordinator.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.assistant_coordinator_sr}"
        >
          {{ $t('fields.assistant_coordinator_id') }}: {{ operatingDay.assistant_coordinator ? operatingDay.assistant_coordinator.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.winch_operator_sr}"
        >
          {{ $t('fields.winch_operator_id') }}: {{ operatingDay.winch_operator ? operatingDay.winch_operator.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.winch_trainee_sr}"
        >
          {{ $t('fields.winch_trainee_id') }}: {{ operatingDay.winch_trainee ? operatingDay.winch_trainee.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.instructor_igt1_sr}"
        >
          {{ $t('fields.instructor_igt1_id') }}: {{ operatingDay.instructor_igt1 ? operatingDay.instructor_igt1.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.instructor_igt2_sr}"
        >
          {{ $t('fields.instructor_igt2_id') }}: {{ operatingDay.instructor_igt2 ? operatingDay.instructor_igt2.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.instructor_igp_sr}"
        >
          {{ $t('fields.instructor_igp_id') }}: {{ operatingDay.instructor_igp ? operatingDay.instructor_igp.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.tow_pilot_sr}"
        >
          {{ $t('fields.tow_pilot_id') }}: {{ operatingDay.tow_pilot ? operatingDay.tow_pilot.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.timer_operator_sr}"
        >
          {{ $t('fields.timer_operator_id') }}: {{ operatingDay.timer_operator ? operatingDay.timer_operator.name : '' }}
        </v-col>
        <v-col
          :class="{'red--text': operatingDay.rope_puller_sr}"
        >
          {{ $t('fields.rope_puller_id') }}: {{ operatingDay.rope_puller ? operatingDay.rope_puller.name : '' }}
        </v-col>
        <v-col>
          {{ $t('fields.comment') }}: {{ operatingDay.comment }}
        </v-col>
        <v-list dense>
          <v-subheader>{{ $t('workers') }}</v-subheader>
          <v-list-item-group
            color="primary"
          >
            <v-list-item
              v-for="(user, i) in operatingDay.users"
              :key="i"
            >
              <v-list-item-content>
                <v-list-item-title v-text="user.name + (user.pilot_info.fai_level ? ' - ' + user.pilot_info.fai_level : '')" />
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </template>
    <template v-slot:button>
      <v-btn
        color="primary"
        class="ma-2"
        @click="getReport({ type: 'operating-day-summary', operating_day_id: operatingDay.id, source_name: date_format})"
      >
        {{ $t('operating_day_summary') }}
        <v-icon left>
          {{ '$download' }}
        </v-icon>
      </v-btn>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import { call, get } from 'vuex-pathify'
  import moment from 'moment'

  export default {
    name: 'OperatingDayInformations',
    props: {
      operatingDay: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        operatingDayInfo: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
      date_format () { return moment(this.operatingDay.start).format('YYYY-MM-DD') },
    },
    methods: {
      getReport: call('action/getReport'),
      closeDialogOperatingDayInfo () {
        this.operatingDayInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
